var map = {
	"./avatar-daniel-base-full.png": 74039,
	"./avatar-daniel-fall-full.png": 28931,
	"./avatar-daniel-spring-full.png": 48051,
	"./avatar-daniel-summer-full.png": 82611,
	"./avatar-daniel-travel-full.png": 17650,
	"./avatar-daniel-winter-full.png": 52079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54278;